// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.instructions {
  padding: 30px 15px;
}
mat-table {
  width: 80%;
  display: flex;
  overflow: auto;
  margin: 30px auto;
  justify-content: center;
}
mat-cell,
mat-footer-cell,
mat-header-cell {
  width: 25%;
  flex: none;
  justify-content: center;
}
.mat-table mat-header-row {
  margin-top: 10px;
  border-bottom: 0;
  min-height: 40px;
}
.mat-table mat-header-cell:first-child {
  padding-left: 0px;
  border-radius: 25px 0 0 25px;
}
.mat-table mat-header-cell:last-child {
  padding-right: 0px;
  border-radius: 0 25px 25px 0;
}
.mat-table mat-header-cell {
  cursor: col-resize;
  justify-content: space-between;
  color: white;
}
.mat-table mat-header-cell:before {
  content: " ";
}
.mat-table mat-header-cell:after {
  font-family: 'Font Awesome 5 Pro', sans-serif;
  font-weight: 300 !important;
  font-size: 16px;
  content: "\\f7a5";
  color: white;
  display: block;
  padding-right: 2px;
  opacity: 0.5;
}
.mat-table mat-header-cell:last-child::after {
  padding-left: 0px !important;
  border-radius: 25px 0 0 25px !important;
  content: "";
}
.mdc-data-table__cell {
  padding: 0px !important;
}
.mat-column-decline {
  background: #ce6161 !important;
}
.mat-column-conditional-low {
  background: #d88949 !important;
}
.mat-column-conditional-high {
  background: #e2b94f !important;
}
.mat-column-accept {
  background: #54a54e !important;
}
`, "",{"version":3,"sources":["webpack://./src/app/shared-components-module/riq-slider/riq-slider.component.less"],"names":[],"mappings":"AAEA;EACE,kBAAA;AADF;AAGA;EACE,UAAA;EACA,aAAA;EACA,cAAA;EACA,iBAAA;EACA,uBAAA;AADF;AAGA;;;EAGE,UAAA;EACA,UAAA;EACA,uBAAA;AADF;AAGA;EACE,gBAAA;EACA,gBAAA;EACA,gBAAA;AADF;AAGA;EACE,iBAAA;EACA,4BAAA;AADF;AAGA;EACE,kBAAA;EACA,4BAAA;AADF;AAGA;EACE,kBAAA;EACA,8BAAA;EACA,YAAA;AADF;AAGA;EACE,YAAA;AADF;AAGA;EACE,6CAAA;EACA,2BAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,YAAA;AADF;AAGA;EACE,4BAAA;EACA,uCAAA;EACA,WAAA;AADF;AAGA;EACE,uBAAA;AADF;AAGA;EACE,8BAAA;AADF;AAGA;EACE,8BAAA;AADF;AAGA;EACE,8BAAA;AADF;AAGA;EACE,8BAAA;AADF","sourcesContent":["@import (reference) '../../../styles.less';\n\n.instructions {\n  padding: 30px 15px;\n}\nmat-table {\n  width: 80%;\n  display: flex;\n  overflow: auto;\n  margin: 30px auto; \n  justify-content: center;\n}\nmat-cell,\nmat-footer-cell,\nmat-header-cell {\n  width: 25%;\n  flex: none;\n  justify-content: center;\n}\n.mat-table mat-header-row {\n  margin-top: 10px;\n  border-bottom: 0;\n  min-height: 40px;\n}\n.mat-table mat-header-cell:first-child {\n  padding-left: 0px;\n  border-radius: 25px 0 0 25px;\n}\n.mat-table mat-header-cell:last-child {\n  padding-right: 0px;\n  border-radius: 0 25px 25px 0;\n}\n.mat-table mat-header-cell {\n  cursor: col-resize;\n  justify-content: space-between;\n  color: white;\n}\n.mat-table mat-header-cell:before {\n  content: \" \";\n}\n.mat-table mat-header-cell:after {\n  font-family: 'Font Awesome 5 Pro', sans-serif;\n  font-weight: 300 !important;\n  font-size: 16px;\n  content: \"\\f7a5\";\n  color: white;\n  display: block;\n  padding-right: 2px;\n  opacity: 0.5;\n}\n.mat-table mat-header-cell:last-child::after {\n  padding-left: 0px !important;\n  border-radius: 25px 0 0 25px !important;\n  content: \"\";\n}\n.mdc-data-table__cell {\n  padding: 0px !important;\n}\n.mat-column-decline {\n  background: @red !important;\n}\n.mat-column-conditional-low {\n  background: @orange !important;\n}\n.mat-column-conditional-high {\n  background: @yellow !important;\n}\n.mat-column-accept {\n  background: @green !important;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
